const organization_rows = [
  { label: 'Organisation name', value: 'Complyon (demo tenant)' },
  { label: 'Reporting currency', value: 'ZAR - R' },
  { label: 'Financial year-end', value: '31 March' },
  { label: 'Default region', value: 'Gauteng' }
];

const compliance_engine_rows = [
  { label: 'Block payments on failed controls', tags: ['Finance', 'Suppliers', 'Controls library', 'Procurement'], on: true },
  { label: 'Enforce Delegation of Authority at intake', tags: ['Delegation of authority', 'OnboardOS handoff', 'Procurement', 'Contracts'], on: true },
  { label: 'Require evidence before stage advance', tags: ['Workflows', 'Evidence vault', 'Controls library'], on: true },
  { label: 'Auto-escalate overdue items', tags: ['My tasks', 'Regulatory calendar', 'Reports'], on: true }
];

const notification_rows = [
  { label: 'Supplier tax expiry alert', value: '30 days before', tags: ['Suppliers', 'Regulatory calendar', 'My tasks', 'Finance', 'Reports'], on: false },
  { label: 'Escalation ladder', value: 'Owner - Manager - Exec - Accounting Officer', tags: ['My tasks', 'Org structure'], on: false },
  { label: 'Weekly compliance digest', value: 'Enabled', tags: ['Reports'], on: true },
  { label: 'Regulator deadline alerts', value: 'Enabled', tags: ['Regulatory calendar', 'Data privacy', 'Reports'], on: true }
];

const security_rows = [
  { label: 'Require MFA for approvers', value: 'On', tags: ['IT security', 'Users & roles'], on: true },
  { label: 'Privileged access review', value: 'Monthly', tags: ['IT security', 'Controls library', 'Regulatory calendar'], on: false },
  { label: 'Apply retention schedule automatically', value: 'On', tags: ['Records & retention', 'Evidence vault'], on: true },
  { label: 'Data residency', value: 'South Africa', tags: ['Data privacy', 'Records & retention'], on: false }
];

export default {
  name: 'SystemSettings',
  data: () => ({
    organization_rows,
    compliance_engine_rows,
    notification_rows,
    security_rows
  })
};
